import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManualHeaderPage } from './manual-header.page';
import { TaxInvoiceEditComponent } from '../../tax-invoice/tax-invoice-select/tax-invoice-edit/tax-invoice-edit.component';
import { AuthGuard } from 'src/app/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: ManualHeaderPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManualHeaderPageRoutingModule {}
